import { useContext } from 'react';
import { SettingsDrawerContext } from '.';
export const useSettingsDrawer = () => {
    const context = useContext(SettingsDrawerContext);
    if (!context) {
        throw new Error('useSettingsDrawer hook must be used as a child to <SettingsDrawer>');
    }
    return context;
};
